module.exports = __webpack_public_path__ + "INA-Logo-2022.png?14c16c0aa96f754788ba34c7d66e4b9b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/associations/INA-Logo-2022.png
// module id = 45
// module chunks = 0